import type {PrimaryConfigOptions} from '@/email-maker/grapesjs-email-editor-plugin/src';
import type {EmailMakerAiRedesignPromptBoxProps} from "@Components/email-maker-ai-redesign-prompt-box/email-maker-ai-redesign-prompt-box";
import type {EmailMakerAiRewritePromptBoxProps} from "@Components/email-maker-ai-rewrite-prompt-box/email-maker-ai-rewrite-prompt-box";
import type {Component} from "grapesjs";
import {fetchAiRedesignRecentPrompt} from "@Libraries/email-campaign-ai-redesign-library";

export default async (opt: PrimaryConfigOptions): Promise<void> => {
  const {editor} = opt;
  const styleManager = editor.StyleManager;
  const redesignPromptBox = document.createElement('div');
  const rewritePromptBox = document.createElement('div');
  const redesignRecentPrompt = await fetchAiRedesignRecentPrompt() ?? undefined;
  let isRedesignsFirstRender = true;


  styleManager.addType(window.PMW.emails.styles.ID_AI_REWRITE_PROMPT_BOX, {
    create(): HTMLDivElement {
      window.PMW.renderEmailMakerAiRedesignPromptBox(redesignPromptBox, getEmailMakerAiRedesignOpts());
      return redesignPromptBox;
    },
  });

  styleManager.addType(window.PMW.emails.styles.ID_SINGLE_COMPONENT_AI_REWRITE_PROMPT_BOX, {
    create(): HTMLDivElement | undefined {
      const selectedComponent = editor.getSelected();
      if (!selectedComponent) {
        return;
      }

      window.PMW.renderEmailMakerAiRewritePromptBox(rewritePromptBox, getEmailMakerAiRewriteOpts(selectedComponent));
      return rewritePromptBox;
    },
  });

  const getEmailMakerAiRedesignOpts = (): EmailMakerAiRedesignPromptBoxProps => {
    const showAnimation = isRedesignsFirstRender;
    if (isRedesignsFirstRender) {
      isRedesignsFirstRender = false;
    }

    return {
      editor: editor,
      recentPrompt: redesignRecentPrompt,
      showInitialAnimation: showAnimation
    }
  }

  const getEmailMakerAiRewriteOpts = (selectedComponent: Component): EmailMakerAiRewritePromptBoxProps => {
    return {
      editor: editor,
      selectedComponent: selectedComponent
    }
  }
};
